import req from "@/assets/js/axios";
/* 科技mall*/
export default {
  // 条件查询机构
  getInstitutes: (params) => {
    return req.apiAxios("POST", "/institute/InstituteController/getInstitutes", params);
  },
  // 条件查询热门店铺
  getHotInstitute: (params) => {
    return req.apiAxios("POST", "/institute/InstituteController/getHotInstitute", params);
  },
  //条件查询机构扩展
  getInstituteExtends: (params) => {
    return req.apiAxios("POST", "/instituteExtend/InstituteExtendController/getInstituteExtends", params);
  },
  //条件查询服务
  getServices: (params) => {
    return req.apiAxios("POST", "/service/ServiceController/getServices", params);
  },
  //条件查询热门服务
  getHotServices: (params) => {
    return req.apiAxios("POST", "/service/ServiceController/getHotServices", params);
  },
  ///条件查询服务规格
  getServiceScales: (params) => {
    return req.apiAxios("POST", "/servicescale/ServiceScaleController/getServiceScales", params);
  },
  //创建服务超市订单
  operationServiceOrder: (params) => {
    return req.apiAxios("POST", "/business/serviceorder/BServiceOrderController/operationServiceOrder", params);
  },
  //非创新券订单
  operationServiceOrderNotCoupon: (params) => {
    return req.apiAxios("POST", "/business/serviceorder/BServiceOrderController/operationServiceOrderNotCoupon", params);
  },
  //查询用户关注服务
  getUserServices: (params) => {
    return req.apiAxios("POST", "/intermediate/userfollow/userservice/UserServiceController/getUserServices", params);
  },
  //创建用户关注服务
  createUserService: (params) => {
    return req.apiAxios("POST", "/intermediate/userfollow/userservice/UserServiceController/createUserService", params);
  },
  //删除用户关注服务
  deleteUserService: (params) => {
    return req.apiAxios("POST", "/intermediate/userfollow/userservice/UserServiceController/deleteUserService", params);
  },
  //推荐商品查询
  recommendService: (params) => {
    return req.apiAxios("POST", "/service/ServiceController/recommendService", params);
  },
  //添加店铺
  createFontInstitute: (params) => {
    return req.apiAxios("POST", "/institute/InstituteController/createFontInstitute", params);
  },
  //修改店铺信息
  updateFontInstitute: (params) => {
    return req.apiAxios("POST", "/institute/InstituteController/updateFontInstitute", params);
  },


  //查询园区店铺或商品
  getStarExtends: (params) => {
    return req.apiAxios("POST", "/starextend/StarExtendController/getStarExtends", params);
  },
  //创建园区店铺或商品
  createStarExtend: (params) => {
    return req.apiAxios("POST", "/starextend/StarExtendController/createStarExtend", params);
  },
  //创建园区店铺或商品
  updateStarExtend: (params) => {
    return req.apiAxios("POST", "/starextend/StarExtendController/updateStarExtend", params);
  },
  //删除法律服务时间段
  deleteStarExtend: (params) => {
    return req.apiAxios("POST", "/starextend/StarExtendController/deleteStarExtend", params);
  },
  //园区店铺开设
  openBServiceShop: (params) => {
    return req.apiAxios("POST", "/business/starextend/BStarExtendController/openBServiceShop", params);
  },
  //发布服务商品
  releaseService: (params) => {
    return req.apiAxios("POST", "/business/service/BServiceController/releaseService", params);
  },
  //创建服务规格
  createFontServiceScale: (params) => {
    return req.apiAxios("POST", "/servicescale/ServiceScaleController/createFontServiceScale", params);
  },
  //更新服务规格
  updateFontServiceScale: (params) => {
    return req.apiAxios("POST", "/servicescale/ServiceScaleController/updateFontServiceScale", params);
  },
  //删除服务规格
  deleteServiceScale: (params) => {
    return req.apiAxios("POST", "/servicescale/ServiceScaleController/deleteServiceScale", params);
  },
  //创建服务
  createFrontService: (params) => {
    return req.apiAxios("POST", "/service/ServiceController/createFrontService", params);
  },
  //更新服务
  updateFrontService: (params) => {
    return req.apiAxios("POST", "/service/ServiceController/updateFrontService", params);
  },
  //查询订单
  getFNOrders: (params) => {
    return req.apiAxios("POST", "/order/OrderController/getOrders", params);
  },
  //订单提交
  submitFNOrder: (params) => {
    return req.apiAxios("POST", "/business/order/BOrderController/submitFNOrder", params);
  },
  //查询订单评价
  getOrderScores: (params) => {
    return req.apiAxios("POST", "/orderscore/OrderScoreController/getOrderScores", params);
  }

};
